import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { IncidentsModel } from '../../../models/incident.models';
import { SoundsNotifyService } from '../../../../../services/sounds-notify.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NzGridModule } from 'ng-zorro-antd/grid';


@Component({
  selector: 'app-incidents',
  standalone: true,
  imports: [CommonModule, TranslateModule, NzGridModule],
  templateUrl: './incidents.component.html',
  styleUrl: './incidents.component.scss'
})
export class IncidentsComponent {

  incidentsMatch: Array<IncidentsModel> = [];
  titleIncident: string = '';
  statusMatch: any;
  private firstLoadData: boolean = false;

  @Input() public isPenaltys: boolean = false;

  @Input() set incidents(data: Array<IncidentsModel>) {
    this.incidentsMatch = data;
  }

  @Input() set title(value: string) {
    this.titleIncident = value;
  }

  @Input() set status(status: any) {
    this.statusMatch = status;
  }

  constructor(
    private soundEffect: SoundsNotifyService
  ) {
    this.firstLoadData = true;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.statusMatch.code >= 1 && this.statusMatch.code <= 8) {
      if (!this.firstLoadData && changes['incidents'].currentValue.length > changes['incidents'].previousValue.length) {
        const incident = changes['incidents'].currentValue[changes['incidents'].currentValue.length - 1];
        if (incident.type.code === 1 || incident.type.code === 8 || incident.type.code === 16 || incident.type.code === 17
          || incident.type.code === 29 || incident.type.code === 30) {
          this.soundEffect.playGold();
          setTimeout(() => {}, 200);
        }
        if (incident.type.code === 11) {
          this.soundEffect.playRefereeBegin();
          setTimeout(() => {}, 200);
        }
        if (incident.type.code === 12 || incident.type.code === 26 || incident.type.code === 27) {
          this.soundEffect.playRefereeEnd();
          setTimeout(() => {}, 200);
        }
      } else this.firstLoadData = false;
    }
  }
}
